import {
  FilterAndSortColumns,
  FilterAndSortOrientations,
} from "@/common/globalTypes/enums/http";

export const defaultValueFilter = "all";
export const defaultValueSorting = FilterAndSortColumns.helpfulCount;
export const filterConstants = [
  {
    column: "rate",
    orientation: defaultValueFilter,
    value: "all",
    name: "allStars",
  },
  {
    column: "rate",
    orientation: "5",
    value: "5",
    name: "5starsOnly",
  },
  {
    column: "rate",
    orientation: "4",
    value: "4",
    name: "4starsOnly",
  },
  {
    column: "rate",
    orientation: "3",
    value: "3",
    name: "3starsOnly",
  },
  {
    column: "rate",
    orientation: "2",
    value: "2",
    name: "2starsOnly",
  },
  {
    column: "rate",
    orientation: "1",
    value: "1",
    name: "1starsOnly",
  },
];

export const sortConstants = [
  {
    column: FilterAndSortColumns.helpfulCount,
    orientation: FilterAndSortOrientations.desc,
    value: defaultValueSorting,
    name: "mostHelpfully",
  },
  {
    column: FilterAndSortColumns.createdAt,
    orientation: FilterAndSortOrientations.desc,
    value: FilterAndSortColumns.createdAt,
    name: "recent",
  },
];
